import { Tooltip } from '@base-ui/react/tooltip';
import type { ReactElement, ReactNode } from 'react';
import { cx } from '@/cva.config';

export interface HoverTipProps {
  align?: 'start' | 'center' | 'end';
  children: ReactNode;
  className?: string;
  delay?: number;
  disabled?: boolean;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  text: ReactNode;
}

export const HoverTip = ({
  align = 'center',
  children,
  className,
  delay,
  disabled,
  placement = 'top',
  text,
}: HoverTipProps) => (
  <Tooltip.Root>
    <Tooltip.Trigger
      delay={delay}
      disabled={disabled}
      render={children as ReactElement}
    />
    <Tooltip.Portal>
      <Tooltip.Positioner align={align} side={placement} sideOffset={6}>
        <Tooltip.Popup
          className={cx(
            'z-70 rounded-md border border-border-active bg-surface px-2 py-1 text-2xs lg:text-xs whitespace-normal text-foreground shadow-xl transition-opacity duration-180 data-ending-style:opacity-0 data-starting-style:opacity-0',
            className,
          )}
        >
          {text}
        </Tooltip.Popup>
      </Tooltip.Positioner>
    </Tooltip.Portal>
  </Tooltip.Root>
);
